import { useEffect, useState } from "react";
import { LabelValueStatisticsData, convertStatisticsData } from "../../../../commons/utilities/statistics-utils";
import StatisticsBar, { StatisticsProps } from "../../team-detail/components/StatisticsBar";
import { AppBox, AppPaper, AppText } from "../../../../commons/components";
import AppTabs, { TabItem } from "../../../../commons/components/Tabs";
import { PlayerPositionEnum } from "../../../../commons/enums/match-player-position-enum";
import { IComparativeStatistics } from "../../../../commons/models/football/interface/i-football-statistics";
import { IFootballPlayerDetail } from "../../../../commons/models/football/interface/i-football-player";

interface PlayerStatisticsChartCardProps {
  statistics: IComparativeStatistics;
  player: IFootballPlayerDetail;
}

const PlayerStatisticsChartCard = ({ player, statistics }: PlayerStatisticsChartCardProps) => {
  const [statsTabs, setStatsTabs] = useState<TabItem[]>([]);
  const [activeTab, setActiveTab] = useState<keyof LabelValueStatisticsData>("attack");
  const [formattedStatistics, setFormattedStatistics] = useState<LabelValueStatisticsData>();

  useEffect(() => {
    const tabItems = [
      { label: "Attack", value: "attack" },
      { label: "Team Play", value: "teamPlay" },
      { label: "Defense", value: "defense" },
      { label: "Discipline", value: "discipline" },
    ];
    if (player.position === PlayerPositionEnum.Goalkeeper) {
      tabItems[0] = { label: "Keeping", value: "keeper" };
      setActiveTab("keeper");
    }
    setStatsTabs(tabItems);
  }, [player]);

  useEffect(() => {
    setFormattedStatistics(convertStatisticsData(statistics));
  }, [statistics]);

  const renderStatistics = () => {
    if (!formattedStatistics) {
      return;
    }
    const data: StatisticsProps[] = formattedStatistics[activeTab];

    if (!data) {
      return <AppText>Nothing to display</AppText>;
    }
    return data?.map((stat) => (
      <StatisticsBar key={stat.label} label={stat.label} total={stat.total} value={stat.value} />
    ));
  };

  return (
    <AppBox flexDirection="column" gap="xs">
      <AppBox>
        <AppPaper padding="none" shadow="xs">
          <AppTabs
            as="button"
            onClick={(e) => setActiveTab(e.value as keyof LabelValueStatisticsData)}
            activeValue={activeTab}
            variant="filled"
            tabItems={statsTabs}
            isFilterTabs
          />
        </AppPaper>
      </AppBox>
      <AppPaper shadow="xs" padding="xs">
        <AppBox flexDirection="column" gap="sm">
          {renderStatistics()}
        </AppBox>
      </AppPaper>
    </AppBox>
  );
};

export default PlayerStatisticsChartCard;
